export default "__VITE_ASSET__9c476053__"